import { z } from 'zod';
import { DeviceType } from '../enums.js';

export const checkDeviceAuthorizationSchema = z.object({
  device_fingerprint: z.string().min(1),
  device_name: z.string().optional(),
  device_type: z.enum(DeviceType),
  browser_info: z.record(z.string(), z.unknown()),
  ip_address: z.string().optional(),
  user_agent: z.string().optional(),
});

export type CheckDeviceAuthorizationPayload = z.infer<typeof checkDeviceAuthorizationSchema>;
